import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NavigationModule } from 'src/core-lib/navigation/navigation.module';
import { TagManagerModule } from 'src/externals/tag-manager/tag-manager.module';
import { CarouselSimpleComponent } from 'src/layout/carousel/carousel-simple.component';
import { GridModule } from 'src/layout/grid/grid.module';
import { MediaModule } from 'src/layout/media/media.module';
import { ArticlesComponent } from './articles.component';



@NgModule({
    declarations: [
        ArticlesComponent
    ],
    imports: [
        CommonModule,
        GridModule,
        MediaModule,
        NavigationModule,
        TagManagerModule,
        TranslateModule,
        CarouselSimpleComponent,
    ]
})
export class ArticlesModule {
    // tslint:disable: object-literal-key-quotes
    static references = {};
    static components = {
        'articlesElement': ArticlesComponent
    };
    // tslint:enable: object-literal-key-quotes}
}
